// extracted by mini-css-extract-plugin
module.exports = {"gdpr":"_1PFV-jZmV8Wp6JnSVFhR5t","checkbox-margin":"_7Ww9GV2DklKo36Y0Lvijd"};